import { MutableRefObject } from "react";

export const scrollToRef = (ref: MutableRefObject<any>) => {
  return () => {
    if (ref && ref.current) {
      window.scrollTo(0, ref.current.offsetTop);
    }
  };
};
